import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../state/reducer/core.reducer';
import {VideoStats} from '../../state/reducer/core.reducer';
import * as dataActions from '../../state/action/core.actions'; 
import { ActivatedRoute, Router} from '@angular/router';
//import { MetadataService } from "../metadata";
import { DataService } from "../data";
import { pluck,takeWhile} from 'rxjs/operators';
import "rxjs/add/operator/take";


@Injectable()
export class StateInteractionService {

    private stateSubscription: Subscription;

    constructor(
       private store: Store<fromRoot.State>,
        private activeRoute: ActivatedRoute,
        private router: Router,   
        private dataService: DataService
    )  {

    }

    private isEmpty(obj) {
        for(var key in obj) {
            if(obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    public getStore( ){
        return this.store;
    }

  
    public getState(): fromRoot.State {
        let rstate: fromRoot.State;
        //let wabadaba = this.store.select("data");
        this.stateSubscription =  this.store.take(1).subscribe(s => rstate = s);
        const res = Object.assign({}, rstate);
        rstate = null;
        return res;
    }

    public getMetadataKey(route: string, params: any): string{
        let urlRoute = route;
        let result = Object.assign({}, params) as Object;
        for (var key in result){
            urlRoute = urlRoute.replace(result[key], key);
        }
        return urlRoute;
    }


    public getStateData(apiUrl: string): any{
        const apiUrlState =  Object.assign({}, this.getState()["reducer"]["dataEntities"][apiUrl]);
        this.stateSubscription.unsubscribe();
        return  (apiUrlState == null) ? null : apiUrlState['data'];
    }

    public getAllExistingPages(apiUrl){
        let target = {};
        const data = this.getState()["reducer"]["dataEntities"];
        const properDataKeys = Object.keys(data).filter(key => {
            key.indexOf(apiUrl) > -1;
        })
        for (let key of properDataKeys){
            Object.assign(target, {key: data[key]});
        }
        this.stateSubscription.unsubscribe();
        return target;
    }

    public deleteStaleSearchItems(term){
        const data = this.getState()["reducer"]["dataEntities"];
        this.stateSubscription.unsubscribe();
        const activePath  = this.getInternalStateValue("activePath");
        const dataKeys = Object.keys(data);
        for (let key of dataKeys){
            if ((key.indexOf('/search/') > -1) && (key.indexOf(term) < 0)) {
                delete  data[key];
            }
        }
        this.stateSubscription.unsubscribe();
        activePath.selectedItem = -1;
        activePath.offsetScrollY = 0.0;
        activePath.childrenState = {};
        this.store.dispatch(new dataActions.SetInternalStateValue({ key: 'activePath', value: activePath }));
    }

    public deleteAllSearchItems(){
        const data = this.getState()["reducer"]["dataEntities"];
        this.stateSubscription.unsubscribe();
        const activePath  = this.getInternalStateValue("activePath");
        const dataKeys = Object.keys(data)
        for (let key of dataKeys){
            if (key.startsWith('/search')) {
                delete  data[key];
            }
        }
        this.stateSubscription.unsubscribe();
    }

    public getRouteDataKey(route: string, params: any): string{
        
        let urlRoute = route;
        let result = Object.assign({}, params) as Object;
        for (var key in result){
            urlRoute = urlRoute.replace(result[key], key);
        }
        return this.getRoute(route)["api_url"];
    }

    public getStaticRouteData(route: string, params: any): Object{

//         let urlRoute = route;
//         let result = Object.assign({}, params) as Object;
//         for (var key in result){
//             urlRoute = urlRoute.replace(result[key], key);
//         }
//         let dataKey, stateData;
//         try{
//             dataKey = this.getRouteDataKey(route, params);
//         }
//         catch(e){
//             dataKey = null;
//         }
        
        try{
            //return this.getState()["reducer"]["dataEntities"][dataKey]["data"];
            const res =  Object.assign({}, this.getState()["reducer"]["dataEntities"][route]["data"]);
            this.stateSubscription.unsubscribe();
            return res;
        }
        catch(e){
            return null;
        }
    }

    public deleteDataEntities(){
        this.store.dispatch(new dataActions.EmptyDataEntities({ }));
        //this.stateInteraction.deleteDataEntities();
    }

    public getRouteData(route: string, params: any): Object{
        
        let urlRoute = route;
        let result = Object.assign({}, params) as Object;
        for (var key in result){
            urlRoute = urlRoute.replace(result[key], key);
        }
        let dataKey, stateData;
        try{
            dataKey = this.getRouteDataKey(route, params);
        }
        catch(e){
            return null;
        }
        try{
            stateData = this.getState()["reducer"]["dataEntities"][dataKey]["data"];
            this.stateSubscription.unsubscribe();
        }
        catch(e){
            stateData = null;
        }
        
        return stateData;
    }


    

    public getRouteDataObservable(route: string, params: any): Object{
//         
//         let urlRoute = route;
//         let result = Object.assign({}, params) as Object;
//         for (var key in result){
//             urlRoute = urlRoute.replace(result[key], key);
//         }// 
//         const dataKey = AppSettings.DATA_API_ENDPOINT + route;
//         return this.store.select(state => {
//             (state.dataEntities[route] == null) ? null :  state.dataEntities[route]["data"];
//         });
            var wow = this.getState();
            this.stateSubscription.unsubscribe();
            return this.store.select(state =>  {
                state.dataEntities[route]["data"]
            
        });
    }


    public getMetadata(key: string): Object{
        const meta =  this.getState()["reducer"].metas[key];
        this.stateSubscription.unsubscribe();
        return meta;
    }

//     public getCurrentDynamicInfo(route: string, params: any){
//         const state = this.getState()["reducer"];
//         const metadataKey = this.getMetadataKey(route, params);  
//         const dataKey = ( state["selectedDataKey"] == null ||  state["selectedDataKey"] == "") ? this.getRoute(route)["api_url"] : state["selectedDataKey"];
//         return Object.assign({}, 
//             { metadata: this.getRouteMetadata(metadataKey) },
//             { data: state["dataEntities"][dataKey]}
//         );
//     }

    public getCurrentSlugInfo(slugName: string, apiUrl: string){
        const state = this.getState()["reducer"];
        this.stateSubscription.unsubscribe();
        return Object.assign({}, 
            { metadata: this.getSlugMetadata(slugName) },
            { data: state["dataEntities"][apiUrl]}
        );
    }
// 
    public getRoute(routeUrl: string): Object{
        const res  = this.getState()["reducer"].routes[routeUrl];
        this.stateSubscription.unsubscribe();
        return res;
    }

    public getRouteSlug(routeUrl: string): Object{
        const res = this.getState()["reducer"].routes[routeUrl]["slug_ids"][0]["slug"];
        this.stateSubscription.unsubscribe();
        return res;
    }
        
    public getSlug(slugName: string): Object{
        const res =  this.getState()["reducer"].slugs[slugName];
        this.stateSubscription.unsubscribe();
        return res;
    }

    public getRouteMetadata(routeUrl: string, params: any): Object{
        const state = this.getState()["reducer"];
        const key = this.getMetadataKey(routeUrl, params);  
        const route = state.routes[key];
        if (route == null) { return null; }
        const mKey = route.config_ids.filter(row => row["level"] == 0)[0]['id'];
        let metadata = state.metas[mKey];
        this.stateSubscription.unsubscribe();
        return metadata;
    }

    public getSlugMetadata(key: string): Object{
        const state = this.getState()["reducer"];
        const slug = state.slugs[key];
        if (slug == null) { return null; }
        const mKey = slug.config_ids.filter(row => row["level"] == 0)[0]['id'];
        let metadata = state.metas[mKey];
        this.stateSubscription.unsubscribe();
        return metadata;
    }


    public getSliceFromStateStore(payload: Object) : Object {
        const newerUrl = this.router.url;
        const key = this.getRoute[newerUrl]["apiUrl"];
        const currentObj  = this.getState()["reducer"].dataEntities[key].data;
        this.stateSubscription.unsubscribe();
        let slice = (currentObj[payload["dataContainer"]] as Array<Object>).find(row => row[payload["sliceKey"]] == payload["sliceKeyValue"]);
        return slice;
    }

    public setSliceInStateStore(payload: Object){
        const newerUrl = this.router.url;
        const key = this.getRoute[newerUrl]["apiUrl"];
        payload["apiUrl"] = key;
        this.store.dispatch(new dataActions.UpdateDataSlice(payload));
    }

    public getInternalStateValue(key: string): any{
        const internalState =  this.getState()["reducer"]["internalState"];
        this.stateSubscription.unsubscribe(); 
        return (internalState == null) ? null : internalState[key];
    }

    public getVideoStats(id: string) : Observable<any> {
        let stats = this.store.select( fromRoot.provideVideoStats );
        //console.log( stats );
        //let obs = this.store.select( fromRoot.provideVideoStats ).subscribe(res=> console.log( res ))
        return stats ? stats : Observable.of();
    }
}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/dynamic/state.interaction.service.ts